module.exports = __webpack_public_path__ + "img/gnu_smart_gallery6.0a5f20e6.jpg";